import { render, staticRenderFns } from "./blockModal.vue?vue&type=template&id=5004e612&scoped=true"
import script from "./blockModal.vue?vue&type=script&lang=js"
export * from "./blockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5004e612",
  null
  
)

export default component.exports